var styles = {"buttonWrapper":"VBG__DS__button-module__-yAAj","darkBrandHighlight":"VBG__DS__button-module__5IyMn","brandHighlight":"VBG__DS__button-module__LuETy"};

export { styles as default };
